import { render, staticRenderFns } from "./ShowDataVerrify.vue?vue&type=template&id=c9a6e1ec&scoped=true"
import script from "./ShowDataVerrify.vue?vue&type=script&lang=js"
export * from "./ShowDataVerrify.vue?vue&type=script&lang=js"
import style0 from "./ShowDataVerrify.vue?vue&type=style&index=0&id=c9a6e1ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a6e1ec",
  null
  
)

export default component.exports